import { blocksClient } from '@/lib/blocks/client';

/**
 * Sign-in through the Blocks OIDC client (`VITE_BLOCKS_OIDC_CLIENT_ID`): IAM's hosted login, where
 * the user picks the provider (e.g. Microsoft), then back to `/login/oidc`.
 */

/** Sends the browser to IAM's hosted login. */
export const startOidcLogin = () => blocksClient.auth.idp.redirectToProvider();

/** Exchanges the `code`/`state` IAM returned to the callback URL for the session. */
export const completeOidcLogin = (callbackUrl: string) =>
  blocksClient.auth.idp.callback(callbackUrl);
